import { createReducer } from "redux-starter-kit";
import {
  startLoadIssuesAction,
  endLoadIssuesAction,
  issuesFailLoadAction,
  filterKeywordEnteredAction,
  delIssueStartAction,
  showCreateAction,
  hideCreateAction,
  recoverIssuesAction,
  updateCurIssue
} from "../actions/issueList";

const INIT_STATE = {
  pdfLoadedID: null,
  pdfIssues: [],
  pdfErrMsg: null,

  webLoadedID: null,
  webIssues: [],
  webErrMsg: null,

  keyword: "",

  showCreateWebModal: false,
  showCreatePdfModal: false,

  currentIssueID: null
};

const issueList = createReducer(INIT_STATE, {
  [startLoadIssuesAction]: (state, action) => {
    if (action.payload.isPdf) {
      state.pdfLoadedID = null;
      state.pdfIssues = [];
      state.pdfErrMsg = null;
    } else {
      state.webLoadedID = null;
      state.webIssues = [];
      state.webErrMsg = null;
    }
  },
  [endLoadIssuesAction]: (state, action) => {
    if (action.payload.isPdf) {
      state.pdfLoadedID = action.payload.titleID;
      state.pdfIssues = action.payload.issues;
      state.pdfErrMsg = null;
    } else {
      state.webLoadedID = action.payload.titleID;
      state.webIssues = action.payload.issues;
      state.webErrMsg = null;
    }
  },
  [issuesFailLoadAction]: (state, action) => {
    if (action.payload.isPdf) {
      state.pdfLoadedID = action.payload.titleID;
      state.pdfIssues = [];
      state.pdfErrMsg = action.payload.errMsg;
    } else {
      state.webLoadedID = action.payload.titleID;
      state.webIssues = [];
      state.webErrMsg = action.payload.errMsg;
    }
  },
  [filterKeywordEnteredAction]: (state, action) => {
    state.keyword = action.payload.keyword;
  },
  [delIssueStartAction]: (state, action) => {
    if (action.payload.isPdf) {
      state.pdfIssues = state.pdfIssues.filter(issue => {
        return issue.id !== action.payload.issueID;
      });
    } else {
      state.webIssues = state.webIssues.filter(issue => {
        return issue.id !== action.payload.issueID;
      });
    }
  },
  [showCreateAction]: (state, action) => {
    if (action.payload.isPdf) {
      state.showCreatePdfModal = true;
    } else {
      state.showCreateWebModal = true;
    }
  },
  [hideCreateAction]: (state, action) => {
    if (action.payload.isPdf) {
      state.showCreatePdfModal = false;
    } else {
      state.showCreateWebModal = false;
    }
  },
  [recoverIssuesAction]: (state, action) => {
    if (action.payload.isPdf) {
      state.pdfIssues = action.payload.allIssues;
    } else {
      state.webIssues = action.payload.allIssues;
    }
  },
  [updateCurIssue]: (state, action) => {
    state.currentIssueID =
      action.payload.currentIssue == null
        ? null
        : action.payload.currentIssue.bid;
  }
});

export default issueList;
